// extracted by mini-css-extract-plugin
export default {"container":"_21HX","checkbox":"_3ed5","icon":"_2q84","selectedIcon":"_3KMA","unselectedIcon":"_1b8C","toggleLabel":"_3jGW"};